"use client";

import { useLanguage } from "@/contexts/LanguageContext";

export default function SectionClosing() {
  const { t } = useLanguage();

  return (
    <section className="bg-surface py-32 px-6 md:px-12 text-center relative overflow-hidden border-t border-border-default">
      {/* Background Elements */}
      <div className="absolute inset-0 flex items-center justify-center opacity-30 pointer-events-none">
        <div className="w-[600px] h-[600px] border border-border-default rounded-full animate-[spin_60s_linear_infinite]" />
        <div className="w-[900px] h-[900px] border border-border-default rounded-full absolute animate-[spin_40s_linear_infinite_reverse]" />
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-primary opacity-20 blur-[150px] rounded-full pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto space-y-10">
        <h2 className="text-3xl md:text-4xl font-black text-text-primary tracking-tight leading-tight">
          {t("sectionClosing.title.before")}{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-brand-secondary to-brand-primary">
            {t("sectionClosing.title.highlight")}
          </span>
        </h2>
        <p className="text-xl md:text-2xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
          {t("sectionClosing.subtitle")}
        </p>

        <div className="pt-8">
          <a
            href="https://calendar.app.google/PuiskR6L6hR51Wfg7"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center gap-3 bg-text-primary text-text-inverted text-lg md:text-xl font-bold py-5 px-12 rounded-full hover:bg-brand-secondary hover:text-white transition-all hover:scale-105 shadow-[0_0_40px_-10px_rgba(255,255,255,0.5)] hover:shadow-[0_0_50px_-10px_rgba(24,84,240,0.6)]"
          >
            {t("sectionClosing.cta")}
            <span className="group-hover:translate-x-1 transition-transform duration-300">
              →
            </span>
          </a>
          <p className="mt-4 text-sm text-text-secondary">
            {t("sectionClosing.ctaSubtitle")}
          </p>
        </div>
      </div>
    </section>
  );
}
